import { Brand, createBranded } from '@deltasierra/type-utilities';
import { HasId, FullAuditable } from '../common/model/traits';
import { LocationCategoryOption, LocationCategoryOptionView } from './LocationCategoryOption';

export interface LocationCategoryGroup extends HasId<LocationCategoryGroupId>, FullAuditable {
    label: string;
    multipleValues: boolean;
    categoryOptions?: LocationCategoryOption[];
}

export interface LocationCategoryGroupView {
    id: number;
    label: string;
    multipleValues: boolean;
    categoryOptions?: LocationCategoryOptionView[];
}

export type LocationCategoryGroupId = Brand<number, 'LocationCategoryGroupId'>;
export const LocationCategoryGroupId = createBranded<LocationCategoryGroupId>();
